import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-8">

        {/* Logo / Brand */}
        <div className="text-white text-2xl font-bold mb-4 md:mb-0">
          Sajilo<span className="text-yellow-500">Bazar</span>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-col sm:flex-row gap-6 text-sm">
          <a href="#home" className="hover:text-yellow-500 transition">Home</a>
          <a href="#menu" className="hover:text-yellow-500 transition">Menu</a>
          <a href="#restaurants" className="hover:text-yellow-500 transition">Restaurants</a>
          <a href="#contact" className="hover:text-yellow-500 transition">Contact</a>
          <a href="#about" className="hover:text-yellow-500 transition">About</a>
        </nav>

        {/* Contact Info */}
        <div className="text-sm space-y-1 text-center md:text-left">
          <p>Contact us:</p>
          <p>Email: sajilobazar2025@gmail.com</p>
          <p>Phone: +9779814711439</p>
        </div>

        {/* Social Media Icons */}
        <div className="flex gap-4">
          <a href="#" aria-label="Facebook" className="hover:text-yellow-500 transition">
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M22 12a10 10 0 10-11.625 9.84v-6.96h-2.9v-2.88h2.9v-2.2c0-2.9 1.73-4.5 4.38-4.5 1.27 0 2.6.23 2.6.23v2.85h-1.47c-1.44 0-1.89.9-1.89 1.82v2.8h3.22l-.51 2.88h-2.71v6.96A10 10 0 0022 12z" />
            </svg>
          </a>
          <a href="#" aria-label="Twitter" className="hover:text-yellow-500 transition">
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M23 3a10.9 10.9 0 01-3.14.86 5.48 5.48 0 002.4-3.02 10.65 10.65 0 01-3.28 1.26 5.42 5.42 0 00-9.24 4.94 15.4 15.4 0 01-11.18-5.68 5.43 5.43 0 001.68 7.26A5.4 5.4 0 012 9.7v.07a5.41 5.41 0 004.35 5.3 5.42 5.42 0 01-2.45.09 5.43 5.43 0 005.06 3.77 10.88 10.88 0 01-6.72 2.31A10.8 10.8 0 010 19.54a15.37 15.37 0 008.29 2.43c9.95 0 15.4-8.24 15.4-15.4 0-.23 0-.45-.02-.67A11 11 0 0023 3z" />
            </svg>
          </a>
          <a href="#" aria-label="Instagram" className="hover:text-yellow-500 transition">
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zM12 7a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm4.75-2.38a1.12 1.12 0 110 2.25 1.12 1.12 0 010-2.25z" />
            </svg>
          </a>
        </div>
      </div>

      <div className="text-center text-gray-500 text-sm mt-8">
        &copy; {new Date().getFullYear()} FoodieHub. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
